import { render, staticRenderFns } from "./dynamic-model-detail.vue?vue&type=template&id=214c4f93&scoped=true"
import script from "./dynamic-model-detail.vue?vue&type=script&lang=js"
export * from "./dynamic-model-detail.vue?vue&type=script&lang=js"
import style0 from "./dynamic-model-detail.vue?vue&type=style&index=0&id=214c4f93&prod&lang=css"
import style1 from "./dynamic-model-detail.vue?vue&type=style&index=1&id=214c4f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c4f93",
  null
  
)

export default component.exports